import { render, staticRenderFns } from "./ToPayCard.vue?vue&type=template&id=126564f2&scoped=true"
import script from "./ToPayCard.vue?vue&type=script&lang=js"
export * from "./ToPayCard.vue?vue&type=script&lang=js"
import style0 from "./ToPayCard.vue?vue&type=style&index=0&id=126564f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126564f2",
  null
  
)

export default component.exports